/* eslint-disable @typescript-eslint/ban-ts-comment */

import AbstractResolvableModel         from '@mathquis/modelx-resolvables/lib/types/AbstractResolvableModel';
import { IResolvableDecoratorOptions } from '@mathquis/modelx-resolvables/lib/types/AbstractResolvableModel';
import { ResolvableModelClass }        from '@mathquis/modelx-resolvables/lib/types/AbstractResolvableModel';
import path                            from '@widesk-core/decorators/path';
import resolvable                      from '@widesk-core/decorators/resolvable';
import dayjs                           from 'dayjs';
import ApiModel                        from '@widesk-core/models/ApiModel';
import { modelUrn }                    from '@widesk-core/decorators/modelUrn';
import urnResource                     from '@widesk-core/decorators/urnResource';
import addable                         from './addable';
import editable                        from './editable';
import deletable                       from './deletable';
import translatable                    from './translatable';
import timestampable                   from './timestampable';

export default {
	addable,
	editable,
	deletable,
	translatable,
	timestampable,
	path,
	urnResource,
	boolean: (target: ApiModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, false);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	date: (target: ApiModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			const self = this as ApiModel;

			const value = self.get(propertyKey);

			if (!value && self.isLoaded && !self.isLoading) {
				if (self.isEmpty) {
					// Si le model est "vide" on retourne quand-même un objet moment
					// pour éviter les erreurs "undefined is not an object"
					return dayjs('0000-01-01');
				}

				return undefined;
			}

			return dayjs(value);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	model: (
		modelClass: ResolvableModelClass<AbstractResolvableModel>,
		options: IResolvableDecoratorOptions = {},
	) => {
		return function (target: AbstractResolvableModel, key: string) {
			return resolvable(modelClass, { attributeName: key, ...options })(target, key);
		};
	},
	modelUrn,
	number: (target: ApiModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, 0);
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	string: (target: ApiModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, '')?.toString() || '';
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
	json: (target: ApiModel, propertyKey: string) => {
		const getter = function () {
			// @ts-ignore
			return this.get(propertyKey, []) || '';
		};

		Object.defineProperty(target, propertyKey, { get: getter, set: () => null });
	},
};
